(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate/assets/javascript/components/use-deposit-limits.js') >= 0) return;  svs.modules.push('/modules/tickets-validate/assets/javascript/components/use-deposit-limits.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect,
  useRef = _React.useRef;
const useDepositLimits = () => {
  const DEPOSITS_SUSPENDED = 'DEPOSITS_SUSPENDED';
  const _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    fetching = _useState2[0],
    setFetching = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasDepositLimits = _useState4[0],
    setHasDepositLimits = _useState4[1];
  const mountedRef = useRef(true);
  useEffect(() => {
    const getDepositLimits = async () => {
      svs.ui.loader.show();
      try {
        svs.ticketsValidate.logger.debug('fetching currentStatus for player..');
        const _await$svs$tur$apiCal = await svs.tur.apiCaller.ticketgames.getPlayerInfo(),
          _await$svs$tur$apiCal2 = _await$svs$tur$apiCal.response,
          response = _await$svs$tur$apiCal2 === void 0 ? {} : _await$svs$tur$apiCal2;
        svs.ticketsValidate.logger.debug('..fetched currentStatus for player');
        if (mountedRef.current) {
          var _response$currentStat;
          setHasDepositLimits((_response$currentStat = response.currentStatus) === null || _response$currentStat === void 0 ? void 0 : _response$currentStat.includes(DEPOSITS_SUSPENDED));
        }
      } catch (e) {
        svs.ticketsValidate.logger.warn('..failed to fetch currentStatus for player..', e);
      }
      setFetching(false);
      svs.ui.loader.hide();
    };
    getDepositLimits();
    return () => {
      mountedRef.current = false;
    };
  }, []);
  return {
    fetchingDepositLimits: fetching,
    hasDepositLimits
  };
};
setGlobal('svs.ticketsValidate.pages.validated.useDepositLimits', useDepositLimits);

 })(window);